import { NavigationSourceType, CatalogType } from '@browsing/utils';
import { ContinueShoppingDataType, StockStatus } from './types';

export const mockData: ContinueShoppingDataType = [
    {
        categoryId: 68510924,
        categoryName: 'Street Style Sneakers',
        hasMore: true,
        configs: Array.from({ length: 9 }, (_, i) => ({
            // to test with the live item PDP
            sku: i === 0 ? 'HU312O00P-Q11' : `PU115O0Q9-K1${11 + i}`,
            brand: 'Nike',
            campaignIdentifier: 'ZZO4138',
            media: [
                {
                    character_code: 'A',
                    media_type: 'IMAGE',
                    path: 'spp-media-p1/8dd9b5ef7b0c418fbeabe9757dfb6e91/06ec9c1fb0284ef38f19c7ea9704cff0.jpg',
                    preview_path:
                        'spp-media-p1/8dd9b5ef7b0c418fbeabe9757dfb6e91/06ec9c1fb0284ef38f19c7ea9704cff0.jpg',
                    alt_text: 'Nike Air Max sneakers',
                },
            ],
            nameCategoryTag: 'Nike Air Max 270 - Sneakers',
            nameColor: '',
            nameShop: '',
            price: 12000,
            specialPrice: 8999,
            navigationSource: NavigationSourceType.ContinueShopping,
            catalogType: CatalogType.Campaign,
            stockStatus: StockStatus.AVAILABLE,
            plusEarlyAccess: false,
            withPrimaryColor: true,
            hasSimilar: true,
            urlPath: {
                '1': '/men/sneakers/nike-air-max-123456',
                '2': '/herren/sneakers/nike-air-max-123456',
            },
            similarPrices: false,
            hasTestMedia: false,
        })),
    },
    {
        categoryId: 224638028,
        categoryName: 'Jackets',
        hasMore: true,
        configs: Array.from({ length: 15 }, (_, i) => ({
            sku: `DI622T03S-${i + 1}`,
            brand: 'The North Face Ultra Max',
            campaignIdentifier: 'CAMP2024_008',
            media: [
                {
                    character_code: 'A',
                    media_type: 'IMAGE',
                    path: 'spp-media-p1/949672d50eb8442193ac7c40c434e96c/f9eb1c69ade145f4b43f2dd598cf3cb7.jpg',
                    preview_path:
                        'spp-media-p1/949672d50eb8442193ac7c40c434e96c/f9eb1c69ade145f4b43f2dd598cf3cb7.jpg',
                    alt_text: 'The North Face puffer jacket',
                },
            ],
            nameCategoryTag: 'The North Face 1996 Retro Nuptse - Jackets',
            nameColor: '',
            nameShop: '',
            price: 29900,
            specialPrice: 19999,
            navigationSource: NavigationSourceType.ContinueShopping,
            catalogType: CatalogType.Campaign,
            stockStatus: StockStatus.AVAILABLE,
            plusEarlyAccess: false,
            withPrimaryColor: true,
            hasSimilar: true,
            urlPath: {
                '1': '/men/jackets/north-face-puffer-567890',
            },
            similarPrices: false,
            hasTestMedia: false,
        })),
    },
    {
        categoryId: 168765739,
        categoryName: 'T-Shirts',
        hasMore: true,
        configs: Array.from({ length: 8 }, (_, i) => ({
            sku: `MA322O0P2-${i + 1}`,
            brand: 'Pegador',
            campaignIdentifier: 'CAMP2024_009',
            media: [
                {
                    character_code: 'A',
                    media_type: 'IMAGE',
                    path: 'spp-media-p1/70012f5b100546d1961faa38b9b37183/103e1e54edf0478f8ec63e5cfc20eaef.jpg',
                    preview_path:
                        'spp-media-p1/70012f5b100546d1961faa38b9b37183/103e1e54edf0478f8ec63e5cfc20eaef.jpg',
                    alt_text: 'Pegador oversized t-shirt',
                },
            ],
            nameCategoryTag: 'Pegador Oversized Tee - T-Shirts',
            nameColor: '',
            nameShop: '',
            price: 4999,
            specialPrice: 2999,
            navigationSource: NavigationSourceType.ContinueShopping,
            catalogType: CatalogType.Campaign,
            stockStatus: StockStatus.AVAILABLE,
            plusEarlyAccess: false,
            withPrimaryColor: true,
            hasSimilar: false,
            urlPath: {
                '1': '/men/t-shirts/pegador-oversized-678901',
            },
            similarPrices: false,
            hasTestMedia: false,
        })),
    },
    {
        categoryId: 228814038,
        categoryName: 'Casual Dresses',
        hasMore: true,
        configs: Array.from({ length: 9 }, (_, i) => ({
            sku: `AN621C2FB-${i + 1}`,
            brand: 'Zara',
            campaignIdentifier: 'CAMP2024_028',
            media: [
                {
                    character_code: 'A',
                    media_type: 'IMAGE',
                    path: 'spp-media-p1/99b5b0876ae34790a559ece9be416b88/0a25ea58e9494c3ab2f8180b9c36af99.jpg',
                    preview_path:
                        'spp-media-p1/99b5b0876ae34790a559ece9be416b88/0a25ea58e9494c3ab2f8180b9c36af99.jpg',
                    alt_text: 'Zara midi dress',
                },
            ],
            nameCategoryTag: 'Zara Midi Dress - Casual Dresses',
            nameColor: '',
            nameShop: '',
            price: 5999,
            specialPrice: 3999,
            navigationSource: NavigationSourceType.ContinueShopping,
            catalogType: CatalogType.Campaign,
            stockStatus: StockStatus.AVAILABLE,
            plusEarlyAccess: false,
            withPrimaryColor: true,
            hasSimilar: true,
            urlPath: {
                '1': '/women/dresses/zara-midi-dress-567890',
            },
            similarPrices: false,
            hasTestMedia: false,
        })),
    },
];

export const mockContinueShoppingData: ContinueShoppingDataType = mockData;

// To check the behavior with one category, uncomment this line
// export const mockContinueShoppingData: ContinueShoppingDataType = [mockData[0]];
